import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import LoaderModal from '@components/LoaderModal/LoaderModal';
import { AppRoutes } from '@routes/appRoutes';

const ProtectedRoute: FC = () => {
    const isAuthenticated = useIsAuthenticated();
    const { inProgress } = useMsal();

    if (inProgress !== InteractionStatus.None) {
        return <LoaderModal isVisible />;
    }

    if (!isAuthenticated) {
        return <Navigate to={AppRoutes.LOGIN_PAGE} replace />;
    }

    return <Outlet />;
};

export default ProtectedRoute;
